// Mattress Reviews & Comparisons modal
import React from "react";
import PropTypes from "prop-types";
import Modal from "../../base-modal.jsx";
import CodePromoButton from "../buttons/code.jsx";
import StepProgressBar from "../../step-progress-bar.jsx";
import {CashbackCodeAction} from "datalayer-service/src/types/enums";

import DataLayerService from "datalayer-service";
const dataLayerService = new DataLayerService(window);

const AboutCashbackModal = ({
    codeEnding,
    storeName,
    storeSlug,
    retailerName,
    onCashbackClick,
    onHide,
}) => {
    const renderModalBody = () => {

      dataLayerService.retailerCashbackCodeInterationEvent({
          action: CashbackCodeAction.VIEW,
          retailerName: retailerName,
          retailerLocation: storeSlug,
        });

        return (
            <>
                <p className="mt-4">
                    When you spend $599+ at select local stores, you can claim
                    an extra Cash Back reward from GoodBed. This is an extra bonus on top of
                    any discounts offered by the store. To qualify, all you need
                    to do is get a personal Cash Back Code here before you buy.
                </p>

                <div className="row justify-content-center mt-4 mb-4">
                    <CodePromoButton
                        codeEnding={codeEnding}
                        onClick={onCashbackClick}
                    />
                </div>

                <p>
                    After your purchase, use this code to claim your reward at{" "}
                    <button className="cashback-btn" onClick={onCashbackClick}>
                        goodbed.com/cashback
                    </button>
                    . Cha-ching!
                </p>

                <div className="how-it-works-container mt-4">
                    <div className="title">How it works</div>

                    <StepProgressBar
                        currentIdx={1}
                        steps={[
                            "Get your Cash Back Code",
                            `Save money at ${storeName}`,
                            "Get Cash Back from GoodBed",
                        ]}
                    />
                </div>

                <p className="mt-5">
                    GoodBed evaluates store reviews and other consumer-friendly
                    factors to hand-pick trusted retailers in each market.
                    Selected stores get to promote this distinction, and when
                    you shop at one of these stores, GoodBed aerns a fee that we
                    share back with you for extra savings!
                </p>
            </>
        );
    };

    return (
        <Modal
            id="about-gb-cashback-modal"
            className="about-gb-cashback-modal"
            bodyTitle="About Goodbed Cash Back"
            body={renderModalBody()}
            onHide={onHide}
        />
    );
};

AboutCashbackModal.propTypes = {
    codeEnding: PropTypes.string,
    storeName: PropTypes.string.isRequired,
    onCashbackClick: PropTypes.func.isRequired,
    onHide: PropTypes.func.isRequired,
};

export default AboutCashbackModal;
